import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  globalStyle,
  handleDangerVisible,
  handleVisible,
} from "../../global/Utils";
import { getCompany } from "../../Actions/CompanyAction";
import {
  addFbrSnroTesting,
  getFbrSnroTesting,
} from "../../Actions/FBRSnroTestingAction";
import { Box, CircularProgress } from "@mui/material";
import { SearchableSelect } from "../Common/SearchableSelect";

const Index = () => {
  const dispatch = useDispatch();

  const { isAddingFbrSnroTesting, fbrSnroListList, isGettingFbrSnroTesting } =
    useSelector((state) => state.FBRSnroTestingReducer);
  const companiesList = useSelector(
    (state) => state.CompanyListReducer?.companiesList || [],
  );
  const [companyId, setCompanyId] = useState("");
  const [showCards, setShowCards] = useState(false);
  const [errors, setErrors] = useState({});
  const [verifyingId, setVerifyingId] = useState(null);

  /* ------------------ SUBMIT ------------------ */
  const handleSubmit = (id) => {
    if (!id) return;
    setVerifyingId(id);
    dispatch(
      addFbrSnroTesting(
        {
          companyId: companyId,
          scenarioId: id,
        },
        handleVisible,
        handleDangerVisible,
      ),
    );
  };

  const handleSearchFbrScenerio = (e) => {
    e.preventDefault();
    if (!companyId) return setErrors({ companyId: "Company is required" });
    dispatch(getFbrSnroTesting(companyId));
    setShowCards(true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(getCompany("", "", ""));
    }, 500);
    return () => clearTimeout(timer);
  }, [dispatch]);

  return (
    <div className="w-full min-h-fit flex flex-col items-center py-4">
      <form className="w-full space-y-6">
        <h2
          className="text-center font-bold text-xl"
          style={{
            fontFamily: globalStyle.fontFamilyHeading,
            color: globalStyle.curveDarkColor,
          }}
        >
          FBR Scenerio Testing
        </h2>
        {/* GRID */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          {/* Company Name */}
          <div>
            <label className="block mb-1 font-medium">
              Company Name<span className="text-red-500">*</span>
            </label>
            <SearchableSelect
              name="companyId"
              value={companyId}
              onChange={(e) => {
                setCompanyId(e.target.value);
                if (e.target.value) {
                  setErrors({ ...errors, companyId: "" });
                }
              }}
              disabled={!companiesList || companiesList.length === 0}
              className={`uppercase w-full px-4 py-2 border rounded-md ${
                errors.companyId ? "border-red-500" : "border-gray-300"
              }`}
            >
              {!companiesList || companiesList.length === 0 ? (
                <option value="">No Companies Available</option>
              ) : (
                <>
                  <option value="">Select</option>
                  {companiesList.map((company) => (
                    <option key={company._id} value={company._id}>
                      {company.companyName} / {company?.ntn}
                    </option>
                  ))}
                </>
              )}
            </SearchableSelect>
            {errors.companyId && (
              <p className="text-red-500 text-sm mt-1">{errors.companyId}</p>
            )}
          </div>
        </div>
        {/* SUBMIT */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          <button
            type="button"
            disabled={isGettingFbrSnroTesting}
            onClick={(e) => {
              handleSearchFbrScenerio(e);
            }}
            className="w-full md:w-[40%] mx-auto block py-2 rounded-md text-white font-bold disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-400"
            style={{ background: globalStyle.buttonColor }}
          >
            {isGettingFbrSnroTesting
              ? "Please Wait..."
              : "Get Company Scenerio for FBR"}
          </button>
        </div>
      </form>
      {showCards && (
        <div className="w-full mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {isGettingFbrSnroTesting ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "80px",
              }}
            >
              <CircularProgress size={50} />
            </Box>
          ) : (
            [...fbrSnroListList]
              ?.sort(
                (a, b) =>
                  Number(a.status === "Verified") -
                    Number(b.status === "Verified") ||
                  a.sequenceNumber - b.sequenceNumber,
              )
              ?.map((item) => {
                const isVerified = item.status === "Verified";
                const isThisVerifying = verifyingId === item._id;
                return (
                  <div
                    key={item._id}
                    className="border rounded-xl shadow-md p-4 bg-white flex flex-col justify-between"
                  >
                    {/* Top Row */}
                    <div className="flex justify-between items-center mb-2">
                      <span
                        className={`text-xs px-2 py-1 rounded-full font-semibold ${
                          item.status === "Verified"
                            ? "bg-green-100 text-green-700"
                            : "bg-orange-100 text-orange-700"
                        }`}
                      >
                        {item.status}
                      </span>
                      <span className="text-xs font-medium text-gray-500">
                        {item.scenarioCode}
                      </span>
                    </div>
                    {/* Name */}
                    <div className="flex-1 flex items-center justify-center text-center py-4">
                      <h3 className="font-semibold text-sm">{item.name}</h3>
                    </div>
                    {/* Verification Count */}
                    <div className="flex items-center justify-center mb-2">
                      <span className="text-xs text-gray-500 mr-1">Verified Count:</span>
                      <span className={`text-sm font-bold ${item.verificationCount > 0 ? "text-green-600" : "text-gray-400"}`}>
                        {item.verificationCount ?? 0}
                      </span>
                    </div>
                    {/* Button */}
                    <div className="mt-3">
                      {isVerified ? (
                        // <div className="text-center text-green-600 font-medium text-sm">
                        //   {item.status}
                        // </div>
                        <button
                          className="w-full py-2 rounded-lg text-white text-sm font-semibold bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 disabled:cursor-not-allowed"
                          onClick={() => handleSubmit(item._id)}
                          disabled={isAddingFbrSnroTesting}
                        >
                          {isAddingFbrSnroTesting
                            ? isThisVerifying
                              ? "Re-Verifying..."
                              : "Please Wait..."
                            : "Re-Verify"}
                        </button>
                      ) : (
                        <button
                          className="w-full py-2 rounded-lg text-white text-sm font-semibold bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 disabled:cursor-not-allowed"
                          onClick={() => handleSubmit(item._id)}
                          disabled={isAddingFbrSnroTesting}
                        >
                          {isAddingFbrSnroTesting
                            ? isThisVerifying
                              ? "Verifying..."
                              : "Please Wait..."
                            : "Verify"}
                        </button>
                      )}
                    </div>
                  </div>
                );
              })
          )}
        </div>
      )}
    </div>
  );
};

export default Index;
